import { addClass, addListener, closest, q, qa, removeClass } from "./utils";
import Filters from "./filters";
import Validators from "./validators";
import Observer from "./observer";

export default class CustomForm {
  private form;
  private inputs;
  private submitBtn;
  public submit;

  constructor(form) {
    this.form = form;
    this.inputs = this.getInputs();
    this.submitBtn = q("[type=submit]", this.form);
    this.submit = new Observer();

    this.inputs.forEach((input) => {
      // Remove invalid class on focus.
      addListener("focus", input, (e) =>
        (<Element>closest(input, ".input-container")).classList.remove(
          "input-invalid"
        )
      );
      // Remove disabled class when all fields are valid.
      addListener("change blur keyup", input, (e) => {
        if (this.isValid()) {
          removeClass(this.submitBtn, "disabled");
        } else {
          addClass(this.submitBtn, "disabled");
        }
      });
      // Add filters to avoid invalid chars.
      addListener(
        "input keydown keyup mousedown mouseup select contextmenu drop",
        input,
        this.applyFilter
      );
      // Avoid that number field changes when mousewheel is moving.
      addListener("wheel", input, (e) => {
        e.preventDefault();
      });
    });
    this.form.addEventListener("submit", (e) => this.handleSubmit(e));
  }

  /**
   * Apply filter to input.
   */
  applyFilter({ target }) {
    const rule = target.dataset["validate"];
    if (rule && rule !== "checked" && Filters[rule]) {
      let valid = Filters[rule](target.value);
      if (valid) {
        target.oldValue = target.value;
        target.oldSelectionStart = target.selectionStart;
        target.oldSelectionEnd = target.selectionEnd;
      } else if (target.hasOwnProperty("oldValue")) {
        target.value = target.oldValue;
      } else {
        target.value = "";
      }
    }
  }

  getData() {
    const data = {};
    this.getInputs().reduce((acc, input: HTMLInputElement) => {
      if (input.dataset["collect"] !== "off") {
        if (input.type === "checkbox") {
          const checkbox = q(`input[name=${input.name}]:checked`);
          if (checkbox) {
            acc[input.name] = checkbox["value"];
          }
        } else {
          acc[input.name] = input.value;
        }
      }
      return acc;
    }, data);
    return data;
  }

  /**
   * Get form fields.
   */
  getInputs(): any[] {
    const collection = <any>qa(".input-container", this.form);
    const inputs: any[] = [];

    for (const container of collection) {
      const query = "[type=text],[type=hidden],[type=number],[type=checkbox]";
      const input = q(query, container);
      if (input) {
        inputs.push(input);
      }
    }
    return inputs;
  }

  /**
   * Handle form submit event.
   * @param {FormEvent} e
   */
  handleSubmit(e) {
    e.preventDefault();
    if (this.isValid(true)) {
      this.submit.fire();
    }
  }

  /**
   * Validate form.
   * @param {boolean} silent
   * @returns {boolean}
   */
  isValid(silent = false) {
    let valid = true;

    this.inputs.forEach((input) => {
      let rule = input.dataset["validate"];
      if (rule) {
        let parent = <Element>closest(input, ".input-container");
        if (input.type === "checkbox") {
          const query = `input[name=${input.name}]:checked`;
          if (qa(query).length === 0) {
            silent && addClass(parent, "input-invalid");
            valid = false;
          } else {
            silent && removeClass(parent, "input-invalid");
          }
        } else {
          if (Validators[rule]) {
            if (!Validators[rule](input.value)) {
              silent && addClass(parent, "input-invalid");
              valid = false;
            } else {
              silent && removeClass(parent, "input-invalid");
            }
          }
        }
      }
    });

    return valid;
  }

  /**
   * Reset form inputs.
   */
  reset() {
    addClass(this.submitBtn, "disabled");
    this.form.reset();
    this.getInputs().forEach((input) => {
      if (input.type === "hidden") {
        input.value = "";
      }
    });
  }
}
